import React, {useContext} from "react";

import {bookVisibilityContext, userInfoContext} from "../../App";
import {useLogMetric} from "../../hooks/useLogMetric";

// Visible only to Karnov employees: lets an employee preview the portal the way an
// external author sees it today (no books) versus how it looks with books.
// The choice lives in bookVisibilityContext (App.tsx), so every table refetches on change.
export default function BookVisibilityToggle() {
    const [userInfo] = useContext(userInfoContext);
    const [includeBooks, setIncludeBooks] = useContext(bookVisibilityContext);
    const logMetric = useLogMetric();

    if (!userInfo?.IsKarnovEmployee) return null;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const next = event.target.checked;
        setIncludeBooks(next);
        logMetric({
            category: "BookVisibility",
            subCategory: next ? "Books shown" : "Books hidden",
            message: `Employee turned the book preview ${next ? "on" : "off"}`,
        });
    };

    return (
        <label className="book-visibility-toggle" htmlFor="book-visibility-toggle">
            <input
                id="book-visibility-toggle"
                type="checkbox"
                checked={includeBooks}
                onChange={handleChange}
            />
            {" "}Vis bøker (forhåndsvisning)
        </label>
    );
}
